module.exports = __webpack_public_path__ + "static/stock_connector_preview-59baa97cdcff71c9e1abe31f2f8dc34e.png";